import axios from "axios";

class FoundationArticles {
  constructor(el) {
    if( !el ) return;

    this.elements = {
      parent: el,
      moreBtn: el.querySelector('.js-foundation-articles__more'),
      container: el.querySelector('.js-foundation-articles__container'),
    };

    this.settings = {
      ajaxUrl: articles_vars.ajaxUrl,
      wpNonce: articles_vars.wpNonce,
      action: articles_vars.action,
      count: this.elements.parent.dataset.count,
    };

    this.state = {
      currentPage: 1,
      loading: false,
    };
    this.init();
  }

  init() {
    this.initButtonClick();
  }

  initButtonClick() {
    if( !this.elements.moreBtn ) return;

    this.elements.moreBtn.addEventListener('click', () => {
      this.loadMoreArticles();
    });
  }

  async loadMoreArticles() {
    if( !this.elements.container ) return;

    const articlesData = await this.getMoreArticles();

    if( articlesData.articles.length !== 0 ) {
      articlesData.articles.forEach(article => {
        this.elements.container.appendChild(article);
      });
    }

    if( !articlesData.readMore ) {
      this.elements.moreBtn.classList.add('hidden');
    }
  }

  setLoading(isLoading) {
    this.state.loading = isLoading;

    if(this.state.loading) {
      this.elements.parent.classList.add('loading');
    } else {
      this.elements.parent.classList.remove('loading');
    }
  }

  async getMoreArticles() {
    try {
      this.state.currentPage += 1;
      this.setLoading(true);

      const response = await axios.get(this.settings.ajaxUrl, {
        params: {
          'action': this.settings.action,
          'paged': this.state.currentPage,
          'wpNonce': this.settings.wpNonce,
          'count': this.settings.count,
        },
        responseType: 'json',
      });

      let wrap = document.createElement('div');
      wrap.innerHTML = response.data.html;

      let articles = wrap.querySelectorAll('.js-foundation-article-tile');

      this.setLoading(false);

      return {
        articles,
        ...response.data,
      }
    } catch(error) {
      this.setLoading(false);

      console.error(error);
      return false;
    }
  }
}

const initFoundationArticles = async () => {
  const blocks = document.querySelectorAll('.js-foundation-articles');

  if( blocks.length === 0 ) return;

  blocks.forEach(block => {
    new FoundationArticles(block);
  });
}
document.addEventListener('DOMContentLoaded', () => {
  initFoundationArticles();
});